import apiClient from './apiClient';

export interface TenantCapabilities {
  mode: 'multi_tenant_saas' | 'dedicated' | 'self_hosted';
  role: string;
  canManageLicense: boolean;
  canCreateAdditionalTenants: boolean;
  canConfigureCustomDomain: boolean;
  canConfigureBranding: boolean;
  canManageEncryptionKeys: boolean;
  canInviteUsers: boolean;
  canChangeMemberRoles: boolean;
}

interface ApiEnvelope<T> {
  success: boolean;
  data: T;
}

const unwrap = <T>(payload: ApiEnvelope<T> | T): T => {
  if (
    payload &&
    typeof payload === 'object' &&
    'success' in (payload as object) &&
    'data' in (payload as object)
  ) {
    return (payload as ApiEnvelope<T>).data;
  }
  return payload as T;
};

export const capabilitiesApi = {
  getMine: async (): Promise<TenantCapabilities> => {
    const { data } = await apiClient.get<ApiEnvelope<TenantCapabilities>>(
      '/auth/me/capabilities',
    );
    return unwrap(data);
  },
};
